/**
 * interactive tool 续聊标记：
 * - 展示输入框（Sender）→ false，走完整对话流
 * - 无输入框、仅卡片问答 → true，防止续聊卡住
 */
export const resolveInteractiveToolOnly = (showChatInput?: boolean): boolean =>
  showChatInput !== true;
